import {Grid2, Skeleton} from '@mui/material';

const TitleSectionSkeleton = () => (
  <Grid2
    display={'flex'}
    alignItems={'start'}
    justifyContent={'space-between'}
    sx={{width: '100%'}}>
    <Grid2>
      <Skeleton variant="text" width={120} height={15} />
    </Grid2>
  </Grid2>
);

export default TitleSectionSkeleton;
